export const useNoImage = () => {

  const { isJps, isHina, serviceType } = useServiceType()

  const noImageBasePath = `/assets/${serviceType}/no-image`

  const defaultNoImage = `${noImageBasePath}/default-no-image.png`
  const otherNoImage = `${noImageBasePath}/null-no-image.png`

  const dataTypeNoImage = (type: string) => {
    return `${noImageBasePath}/${type}-no-image.png`
  }

  const itemDetailNoImage = `${noImageBasePath}/item-no-image-small.png`

  const getItemNoImageType = (i: Item) => {
    if (isJps) {
      return isEmptyArray(i.common.category) ? 'item' : i.common.category[0]
    } else if (isHina) {
      // 値としてはコードのdigital_contents_type(image, video, text, sound, website, other)が対象となる
      return isEmpty(i.common.contentsType) ? 'other' : i.common.contentsType
    } else {
      return 'item'
    }
  }

  const getItemNoImage = (i: Item) => {
    return `${noImageBasePath}/${getItemNoImageType(i)}-no-image-small.png`
  }

  return {
    defaultNoImage,
    otherNoImage,
    dataTypeNoImage,
    itemDetailNoImage,
    getItemNoImageType,
    getItemNoImage,
  }

}

